<div *ngIf="browserIsValid" [id]="htmlId ? htmlId : 'kazaplan-viewer'" style="border: medium none;width: 100%;"></div>
